import { App } from './lib/App.js';
import { State } from './lib/State.js';
import { API } from './lib/API.js';
import { Router } from './lib/Router.js';
import { Account } from './lib/Account.js';
import config from './config.json';

window.app = new App(
	window,
	document,
	history,
	new State(),
	API.fromObject(config.api),
	Router.fromObject({
		history,
		document,
		window,
		titleAppend: 'Kinex Physician Portal'
	}),
	Account.fromObject({}),
	config.version
);